import { lazy } from 'react';
const LoadingDetailFactory = lazy(() => import('./LoadingDetailFactory'));

const LoadingDetailFactoryRoutes = [
  {
    path: '/loading-date-update',
    component: LoadingDetailFactory
  }
];

export default LoadingDetailFactoryRoutes;
